"use client";

import { StoreImage } from "@/components/StoreImage";
import { useStoreBranding } from "@/lib/supabase/siteSettings";

/**
 * Gambar default produk TANPA FOTO: logo toko tenant (site_settings
 * `store_logo_url`) tampil redup di tengah bingkai foto — pengganti kotak
 * polos. Logo belum diunggah → tidak merender apa-apa (latar polos lama),
 * karena memang tak ada identitas toko yang bisa ditampilkan.
 *
 * Aman dipanggil per-kartu walau kartu dirender puluhan kali per layar:
 * `useStoreBranding` membaca `fetchSiteSettings` yang ber-cache 60 dtk +
 * dedup in-flight, jadi semua kartu berbagi SATU round-trip (lihat catatan
 * `useShippingRateEnabled` di siteSettings.ts).
 *
 * JANGAN dipakai di permukaan katalog reseller (/toko/…): di sana logo toko
 * induk justru harus disembunyikan (white-label) — pemanggil menekan lewat
 * `isCatalogHref` / `catalogMode`.
 */
export function ProductPhotoFallback({ sizes }: { sizes?: string }) {
  const { logoUrl } = useStoreBranding();
  if (!logoUrl) return null;
  return (
    // Padding % (relatif lebar bingkai) menjaga proporsi logo di kartu 144px
    // maupun galeri 448px; opacity membedakannya dari foto produk sungguhan.
    <div aria-hidden className="absolute inset-0 p-[18%]">
      <div className="relative h-full w-full opacity-40">
        <StoreImage
          src={logoUrl}
          alt=""
          fill
          sizes={sizes}
          className="object-contain"
        />
      </div>
    </div>
  );
}
